var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"statistics"},[_vm._v(" 圆形图表 ")]),_c('div',{staticClass:"increment"},[_vm._v(" 数据增量 ")])]),_c('div',{staticClass:"Chart"},[_vm._v(" 订单，收入，电量曲线 ")])])
}]

export { render, staticRenderFns }